<template>
  <div class="w-full fixed h-full flex justify-center items-center mdmax:relative bg-white">
    <div class="w-7/12 bg-white h-full" v-if="!isMobile">
      <div class="polygon bg-neutral-600 h-full flex items-start flex-col justify-center gap-10 pl-20">
        <p class="text-4xl font-bold text-white">6 Keuntungan Bergabung Dengan linknau</p>

        <div class="w-10/12">
          <div class="flex gap-6 mb-10 mdmax:flex-col">
            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Currency width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Cashback</p>
                <p class="text-neutral-400 text-sm">
                  Selain diskon harga, kamu juga akan mendapatkan tambahan cashback jutaan rupiah.
                </p>
              </div>
            </div>

            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Courier width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Kurir Toko</p>
                <p class="text-neutral-400 text-sm">
                  Sekarang kamu bisa memiliki Kurir Toko sendiri dengan dukungan multiple logistik.
                </p>
              </div>
            </div>
          </div>

          <div class="flex gap-6 mb-10 mdmax:flex-col">
            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Discount width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Variasi Promo</p>
                <p class="text-neutral-400 text-sm">
                  Dapatkan variasi promo lebih banyak dengan menjadi mitra Linknau for Business.
                </p>
              </div>
            </div>

            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Grid width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Akses Khusus</p>
                <p class="text-neutral-400 text-sm">
                  Linknau menyediakan akses khusus kepada setiap mitra melalui sistem antarmuka tersendiri.
                </p>
              </div>
            </div>
          </div>

          <div class="flex gap-6 mdmax:flex-col">
            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Integration width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Kemudahan Integrasi</p>
                <p class="text-neutral-400 text-sm">
                  Sudah punya sistemnya? Kita masih bisa sinergi melalui API.
                </p>
              </div>
            </div>

            <div class="flex-1 flex items-start gap-6">
              <span class="text-primary-500"><Truck width="48" height="48"/></span>
              <div class="text-left text-white">
                <p class="text-2xl font-bold mb-3">Logistik Terlengkap</p>
                <p class="text-neutral-400 text-sm">
                  Linknau menyediakan lebih banyak pilihan mitra pengiriman.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-5/12 bg-white relative h-full mdmax:w-full overflow-y-auto">
      <div v-if="!isRegistrationSuccess" class="px-24 py-20 flex flex-col justify-center h-full mdmax:px-10 mdmax:py-10">
        <div class="text-center mb-12">
          <img src="@/assets/images/logos/logo-color.png" class="inline-block w-48" />
        </div>

        <div class="form text-left">
          <h2 class="text-2xl font-bold text-neutral-800 mb-2">Daftar Mitra Baru</h2>
          <p class="text-neutral-500 mb-8">
            Lengkapi data di bawah untuk memulai kemitraan.
          </p>

          <div class="space-y-6">
            <TextField v-model="payload.business_name" label="Nama Perusahaan" placeholder="Masukkan Nama Perusahaan" :required="true" :error="errors.business_name" />

            <TextField v-model="payload.sender_name" label="Nama Admin Pengirim" placeholder="Masukan Nama Admin" :required="true" :error="errors.sender_name" />

            <TextField v-model="payload.email" label="Email" placeholder="Masukan Email" :required="true" :error="errors.email" />

            <TextField type="number" v-model="payload.sender_phone" label="No. Handphone" placeholder="Masukan No Handphone" :required="true" :error="errors.sender_phone" />
          </div>

          <div class="w-full mt-10">
            <Button buttonText="Kirim Pendaftaran" size="full" @action="submit" :disabled="!isValid" />
          </div>
        </div>
      </div>

      <template v-else>
        <div class="h-full w-full flex flex-col justify-center items-center px-10 text-center">
          <Send width="120" height="120" />
          <h2 class="mt-8 mb-4 text-3xl font-bold text-neutral-800">
            Cek Email Anda
          </h2>
          <p class="text-neutral-600 mb-10 leading-relaxed">
            Link verifikasi telah dikirim ke <br />
            <b class="text-neutral-800">{{ payload.email }}</b>
          </p>
          <Button buttonText="Kembali Ke Login" @action="goToLogin" />
        </div>
      </template>
    </div>

    <Toast />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { isNotEmptyError } from '@/util/form-validator'

export default {
  name: 'RegistrationPage',

  components: {
    TextField: () => import('@/components/Forms/TextField'),
    Button: () => import('@/components/Forms/Button'),
    Toast: () => import('@/components/Toast/Toast'),
    Currency: () => import('@/components/Icons/Currency'),
    Courier: () => import('@/components/Icons/Courier'),
    Discount: () => import('@/components/Icons/Discount'),
    Grid: () => import('@/components/Icons/Grid'),
    Integration: () => import('@/components/Icons/Integration'),
    Truck: () => import('@/components/Icons/Truck'),
    Send: () => import('@/components/Icons/Send')
  },

  data() {
    return {
      payload: {
        business_name: '',
        email: '',
        sender_phone: '',
        sender_name: ''
      },
      errors: {},
      isRegistrationSuccess: false
    }
  },

  computed: {
    ...mapGetters('common', ['isMobile']),
    isValid() {
      return isNotEmptyError(this.payload).length === 0
    }
  },

  methods: {
    ...mapActions('merchant', ['merchantRegistration']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),

    goToLogin() {
      this.$router.push('/login')
    },

    submit() {
      if (!this.isValid) return

      this.showLoading()

      const finalPayload = {
        email: this.payload.email,
        name: this.payload.business_name,
        sender_name: this.payload.sender_name,
        sender_phone: this.payload.sender_phone,
        address: '',
        detail_address: '',
        business_field: '',
        volume_transaction_monthly: '',
        categories: '',
        latlng: '',
        area_code: 0,
        user_type: process.env.VUE_APP_USER_TYPE
      }

      this.merchantRegistration({ payloads: finalPayload })
        .then(() => {
          this.hideLoading()

          this.setToast({
            options: {
              type: 'success',
              primaryText: 'Registrasi Berhasil',
              secondaryText: 'Silakan cek email untuk verifikasi akun'
            }
          })

          this.isRegistrationSuccess = true
        })
        .catch(err => {
          this.hideLoading()
          this.setToast({
            options: {
              type: 'danger',
              primaryText: 'Registrasi Gagal',
              secondaryText: err?.response?.data?.message || 'G001'
            }
          })
        })
    }
  }
}
</script>

<style scoped>
.polygon {
  clip-path: polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0 100%);
}
</style>